import React from 'react';
import { UserIcon } from './Icons';

const UserWithAvatar = ({ className = 'user-avatar-sm', user }) => {
  return (
    <div className='d-flex align-items-center'>
      <div
        className={`${className} mr-8 rounded-100p overflow-hidden border d-flex flex-column justify-content-center align-items-center`}
      >
        {!user.picture && <UserIcon />}
        {user.picture && <img src={user.picture} alt='avatar' />}
      </div>
      {user.name}
    </div>
  );
};

export default UserWithAvatar;
